import * as React from "react";
import { cx } from "../util.js";

export interface ProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Current value. */
  value: number;
  /** Maximum value. @default 100 */
  max?: number;
}
/** Goal/word-count progress, filled with the amber momentum accent. */
export function ProgressBar({ value, max = 100, className, ...rest }: ProgressBarProps) {
  const safeMax = Number.isFinite(max) && max > 0 ? max : 100;
  const safeValue = Number.isFinite(value) ? Math.max(0, Math.min(safeMax, value)) : 0;
  const pct = safeValue / safeMax;
  return (
    <div
      className={cx("ip-progress", className)}
      role="progressbar"
      aria-valuenow={safeValue}
      aria-valuemin={0}
      aria-valuemax={safeMax}
      {...rest}
    >
      <span style={{ transform: `scaleX(${pct})` }} />
    </div>
  );
}
